import Standard from './Standard'

export default Standard
